import React from "react";

// Img
import editIcon from "../../../assets/svg/action/ic-kebab.svg";

// Jds
import { Icon } from "@jds/core";

export default function KebabButton(props) {
  return (
    <Icon
      ic={<img src={editIcon} alt="kebab menu icon" />}
      size="large"
      {...props}
    />
  );
}
